export class CommissionAdjustment {
    public iCommissionAdjustmentId?:number;
    public creditId?:number;
    public iCreditIdMotivo?:number;
    public employeeId?:string;
    public employeeName?:string;
    public capitalAmount?:number;
    public commissionPercent?:number;    
    public commissionAmount?:number;
    public commissionAdjustmentAmount?:number;
    public commissionFinalAmount?:number;
    public CommissionAdjustmentFree?:number;
    public CommissionAdjustmentAvalible?: number;
    public executionDate?:string;
    public createdUserId?:string; 
    public simulated?:number; 
    public businessLineId?:number;
    public productId?:number;
    public enviado?:number;
    public comentario?:string;
    public claveEmpleadoDispersion?:string;
}